import React from 'react';

function EditDefaul({ fill = '#1D1C1D', width = 20, height = 20, style }) {
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.75 16.25H4.66667L13.8958 7.02085L12.9792 6.10419L3.75 15.3334V16.25ZM16.5417 6.12502L13.875 3.45835L14.75 2.58335C14.9861 2.34724 15.2778 2.22919 15.625 2.22919C15.9722 2.22919 16.2639 2.34724 16.5 2.58335L17.4167 3.50002C17.6528 3.73613 17.7708 4.0278 17.7708 4.37502C17.7708 4.72224 17.6528 5.01391 17.4167 5.25002L16.5417 6.12502ZM15.6667 7.00002L5.16667 17.5H2.5V14.8334L13 4.33335L15.6667 7.00002ZM13.4375 6.56252L12.9792 6.10419L13.8958 7.02085L13.4375 6.56252Z" fill={fill} />
    </svg>

  );
}

export default EditDefaul;
